import { AppConfig } from '../../app.config';

export function initializer(appConfig: AppConfig): () => Promise<void> {
  return () =>
    new Promise<void>((resolve, reject) => {
      appConfig.load().then(
        () => resolve(),
        (error: any) => reject(error)
      );
    });
}
